// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import axios from 'axios';
import { getConfig } from '../../reducers/portalConfig';
import * as CONSTANTS from '../../constants';

export const fetchVersion = () => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  const url = `${portal?.hostname}/api/portal/version`;

  dispatch({ type: CONSTANTS.VERSION_REQUEST })
  await axios.get(url)
    .then((response) => {
      if (response.status === 201 || response.status === 200) {
        dispatch({ type: CONSTANTS.VERSION_SUCCESS, payload: response.data });
      }
    })
    .catch((error) =>
      dispatch({ type: CONSTANTS.VERSION_ERROR, payload: error }),
    );
}

export const fetchPublicAuthSchemes = () => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  const url = `${portal?.hostname}/api/${portal?.tenantPrefix}/public/auth/schemes`

  dispatch({ type: CONSTANTS.PUBLIC_AUTH_SCHEMES_LIST_REQUEST })
  await axios.get(url)
    .then((response) => {
      if (response.status === 201 || response.status === 200) {
        const responseData = response.data;
        const authSchemes = responseData.authSchemes;
        const oktaAuthScheme = {
          name : "SSO Login",
          credsReqd : true,
          oktaAcsUrl : responseData.oktaAcsUrl,
          oktaDomain : responseData.oktaDomain,
          isOktaProxied : responseData.isOktaProxied,
          isProxiedAuthScheme: (responseData.isSamlProxied || responseData.isOktaProxied),
          isSamlProxied : responseData.isSamlProxied,
          samlProxyDomain : responseData.samlProxyDomain,
          samlProxySSOUrl : responseData.samlProxySSOUrl,
          tenantId : authSchemes[0].tenantId,
          authMethod : 'SAML_PROXIED',
          defaultConfig : false,
          links : [],
          showFyp : false,
          uuid : 'proxied_saml_local_uuid',
          samlPresent: false,
        };
        authSchemes.push(oktaAuthScheme);
        if(responseData.isOktaProxied || responseData.isSamlProxied) {
          authSchemes
            .filter((scheme) => scheme.authMethod === 'SAML')
            .forEach((scheme) => {
              oktaAuthScheme.samlPresent = true;
              if (scheme.defaultConfig) {
                oktaAuthScheme.defaultConfig = true;
              }
            });
          responseData.authSchemes = authSchemes.filter(function(scheme) {return scheme.authMethod !== 'SAML';});
        }

        dispatch({ type: CONSTANTS.PUBLIC_AUTH_SCHEMES_LIST_SUCCESS, payload: responseData });
      }
    })
    .catch((error) =>
      dispatch({ type: CONSTANTS.PUBLIC_AUTH_SCHEMES_LIST_ERROR, payload: error }),
    );
}

export const fetchAuthSchemePublicKey = (payload) => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  const url = `${portal?.hostname}/api/${portal?.tenantPrefix}/authenticate/getPublicKey?authConfigUuid=${payload.uuid}`;

  dispatch({ type: CONSTANTS.GET_AUTH_SCHEME_PUBLIC_KEY_REQUEST, payload: { uuid: payload.uuid } })
  await axios.get(url)
    .then((response) => {
      if (response.status === 201 || response.status === 200) {
        dispatch({
          type: CONSTANTS.GET_AUTH_SCHEME_PUBLIC_KEY_SUCCESS,
          payload: { data: response.data, uuid: payload.uuid },
        });
      }
    })
    .catch((error) =>
      dispatch({
        type: CONSTANTS.GET_AUTH_SCHEME_PUBLIC_KEY_ERROR,
        payload: { error, uuid: payload.uuid },
      }),
    );
}

export const authenticateLogin = (payload, options) => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  const url = `${portal?.hostname}/api/${portal?.tenantPrefix}/authenticate/login`;

  dispatch({ type: CONSTANTS.AUTHENTICATE_LOGIN_REQUEST })

  const headers = {};
  if(options.publicKey) {
    headers['Public-Key'] = options.publicKey;
  }

  await axios.post(url, payload, { credentials: 'include', headers })
    .then((response) => {
      if (response.status === 201 || response.status === 200) {
        dispatch({ type: CONSTANTS.AUTHENTICATE_LOGIN_SUCCESS, payload: response.data || true });
      }
    })
    .catch((error) => {
      const response = error?.response || {};
      const responseData = response.data || {};
      const responseCode = responseData.respCode;
      const responseErrorCode = responseData.errorCode;

      if (responseCode === "13217") {
        dispatch({ type: CONSTANTS.AUTHENTICATE_LOGIN_ERROR, payload: { type: 'PASSWORD_EXPIRY', details: responseData } });
        return;
      }

      if (responseCode === "14007") {
        dispatch({ type: CONSTANTS.AUTHENTICATE_LOGIN_ERROR, payload: { type: 'MULTIPLE_SESSIONS', details: null } });
        return;
      }

      if ((responseCode === "13218") || (responseErrorCode)) {
        if (responseCode === "14002" && options.hasDetectedMultipleSessions) {
          dispatch({ type: CONSTANTS.AUTHENTICATE_LOGIN_ERROR, payload: { type: 'ERROR_CREDENTIALS', details: null } });
          return;
        }

        dispatch({ type: CONSTANTS.AUTHENTICATE_LOGIN_ERROR, payload: { type: 'ERROR_REDIRECT', details: responseErrorCode } });
        return;
      }

      dispatch({ type: CONSTANTS.AUTHENTICATE_LOGIN_ERROR, payload: { type: 'ERROR_REDIRECT_GENERIC', details: null } });
    });
};